import type { useHistory } from 'react-router-dom';
import { WebOffer } from '@applied/proto/web_services/candidate_experience/proto/web_offer_pb';
import type { JsonValue } from '@protobuf-ts/runtime';
import type { MessageType } from '@protobuf-ts/runtime';
import type { ResponseData } from 'api/http_requests';
import { getData, makeAuthenticatedRequest } from 'api/http_requests';

const webOfferType = WebOffer as MessageType<WebOffer>;

export async function getWebOffer(
  history: ReturnType<typeof useHistory>,
  candidateEmail?: string,
): Promise<WebOffer | null> {
  const requestWebOffer = (): Promise<ResponseData<JsonValue>> =>
    getData(candidateEmail ? `/api/web_offer/${candidateEmail}` : '/api/web_offer/');
  try {
    const response = await makeAuthenticatedRequest(requestWebOffer, history);
    if (!response || response.jsonPayload === null) {
      return null;
    }
    return webOfferType.fromJson(response.jsonPayload);
  } catch (error) {
    if (error.status === 410) {
      history.push('/expired');
      return null;
    }
    throw error;
  }
}
